import { defineStore } from 'pinia'
import { mapbygroupx} from "@/api/system";

export const useDicStore = defineStore({
  id: 'layout',
  state: () => ({
    // 菜单数据
    dic:{}
  }),
  getters: {

  },
  actions: {
      async getDicName (groupx,code){
          if (this.dic[groupx]===undefined) {
              const data = await mapbygroupx({
                  groupx:groupx,
              })
              this.dic[groupx]=data.dataObj
          }
          return this.dic[groupx][code]
      },
       async setDicName(groupx, code) {
           if (this.dic[groupx] == undefined) {
               const data = await mapbygroupx({
                   groupx: groupx,
               })
               this.dic[groupx] = data.dataObj
           }
           return this.dic[groupx][code]
       },
      async getDic(groupx){
          if (this.dic[groupx]===undefined) {
              const data = await mapbygroupx({
                  groupx:groupx,
              })
              this.dic[groupx]=data.dataObj
          }
          return this.dic[groupx]
      },
      async setDic(groupx) {
          if (this.dic[groupx] == undefined) {
              const data = await mapbygroupx({
                  groupx: groupx,
              })
              this.dic[groupx] = data.dataObj
          }
          return this.dic[groupx]
      }
  }
})

